import { VText } from '@vake/ui-kit';
import { FC } from 'react';
import Analysing from './Analysing';

const Footer: FC = () => (
    <div className="flex flex-col items-center p-4">
        <div>
            <img src="images/vakeLogo.png" alt="VAKE" />
        </div>
        <Analysing />
        <VText>Universitetsgata 2, 0164 Oslo, Norway</VText>
        <VText>connect@vake.ai</VText>
        <VText>Tel.: +47 922 50 890</VText>
    </div>
);

export default Footer;
